export default "__VITE_ASSET__c829d7a3__"